import { SWITCH_MODE } from "../constants/modeConstants";

export const switchMode = (mode) => (dispatch) => {
  dispatch({ type: SWITCH_MODE, payload: mode });
};
